module.exports = __webpack_public_path__ + "static/img/areaA-23.b75166f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-23.png
// module id = 935
// module chunks = 1